/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiActivityLogResponse,
  ApiAddCaseMemberDto,
  ApiAddDocumentToCaseDto,
  ApiAddTaskDocumentsDtoV2,
  ApiAnalyticsResponse,
  ApiCaseMemberEnrichedResponseV2,
  ApiCaseMemberGroupedResponseV2,
  ApiCaseMemberResponse,
  ApiCaseMemberResponseV2,
  ApiCaseResponseV2,
  ApiChatPermissionResponse,
  ApiCreateActivityLogDto,
  ApiCreateCaseDto,
  ApiCreateCaseMemberInternalDto,
  ApiCreateDocumentDtoV2,
  ApiCreateDocumentMultipartBodyDtoV2,
  ApiCreateTaskDtoV2,
  ApiDashboardResponseV2,
  ApiDocumentDownloadResponse,
  ApiDocumentResponseV2,
  ApiDownloadDocumentDto,
  ApiGrantPermissionDto,
  ApiGrantRoleDto,
  ApiPermissionResponse,
  ApiRemoveCaseMemberDto,
  ApiRemoveDocumentFromCaseDto,
  ApiRoleResponse,
  ApiSuccessResponse,
  ApiSyncCaseMemberCasesDto,
  ApiSyncCaseMembersDto,
  ApiTaskResponseV2,
  ApiUpdateCaseDto,
  ApiUpdateCaseMemberDtoV2,
  ApiUpdateCaseMemberSelfDtoV2,
  ApiUpdateChatPermissionsDto,
  ApiUpdateDocumentDtoV2,
  ApiUpdateTaskDtoV2,
  ApiUserPermissionResponse,
  ApiUserRoleResponse,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwCase<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2FindAll
   * @summary Get list of all cases (V2)
   * @request GET:/gtw/case/v2/cases
   * @secure
   * @response `200` `(ApiCaseResponseV2)[]` List of cases successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2FindAll = (params: RequestParams = {}) =>
    this.request<ApiCaseResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/cases`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2Create
   * @summary Create a new case (V2)
   * @request POST:/gtw/case/v2/cases
   * @secure
   * @response `201` `ApiCaseResponseV2` Case successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2Create = (
    data: ApiCreateCaseDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/cases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2FindOne
   * @summary Get a case by ID (V2)
   * @request GET:/gtw/case/v2/cases/{id}
   * @secure
   * @response `200` `ApiCaseResponseV2` Case successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2FindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiCaseResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2Update
   * @summary Update a case (V2)
   * @request PUT:/gtw/case/v2/cases/{id}
   * @secure
   * @response `200` `ApiCaseResponseV2` Case successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2Update = (
    id: string,
    data: ApiUpdateCaseDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2Delete
   * @summary Delete a case (V2)
   * @request DELETE:/gtw/case/v2/cases/{id}
   * @secure
   * @response `204` `void` Case successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2Delete = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2AddMember
   * @summary Add a member to a case (V2)
   * @request POST:/gtw/case/v2/cases/{id}/members
   * @secure
   * @response `201` `ApiCaseMemberResponseV2` Member successfully added to case
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2AddMember = (
    id: string,
    data: ApiAddCaseMemberDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}/members`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2RemoveMember
   * @summary Remove a member from a case (V2)
   * @request POST:/gtw/case/v2/cases/{id}/members/remove
   * @secure
   * @response `200` `void` Member successfully removed from case
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2RemoveMember = (
    id: string,
    data: ApiRemoveCaseMemberDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}/members/remove`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncMemberCases
   * @summary Synchronize a member participation in non-private cases based on case list (V2)
   * @request POST:/gtw/case/v2/cases/members/sync
   * @secure
   * @response `200` `void` Member participation in cases successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncMemberCases = (
    data: ApiSyncCaseMemberCasesDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/members/sync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncCaseMembers
   * @summary Synchronize case members based on profile list for one case (V2)
   * @request POST:/gtw/case/v2/cases/{id}/members/sync
   * @secure
   * @response `200` `void` Case members successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncCaseMembers = (
    id: string,
    data: ApiSyncCaseMembersDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}/members/sync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncMemberCases
   * @summary Synchronize a member participation in non-private cases based on case list (V2)
   * @request POST:/gtw/case/v2/cases/members/sync
   * @secure
   * @response `200` `void` Member participation in cases successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncMemberCases = (
    data: ApiSyncCaseMemberCasesDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/members/sync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncCaseMembers
   * @summary Synchronize case members based on profile list for one case (V2)
   * @request POST:/gtw/case/v2/cases/{id}/members/sync
   * @secure
   * @response `200` `void` Case members successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncCaseMembers = (
    id: string,
    data: ApiSyncCaseMembersDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}/members/sync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncMemberCases
   * @summary Synchronize a member participation in non-private cases based on case list (V2)
   * @request POST:/gtw/case/v2/cases/members/sync
   * @secure
   * @response `200` `void` Member participation in cases successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncMemberCases = (data: ApiSyncCaseMemberCasesDto, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/members/sync`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Cases V2
   * @name CaseControllerV2SyncCaseMembers
   * @summary Synchronize case members based on profile list for one case (V2)
   * @request POST:/gtw/case/v2/cases/{id}/members/sync
   * @secure
   * @response `200` `void` Case members successfully synchronized
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseControllerV2SyncCaseMembers = (
    id: string,
    data: ApiSyncCaseMembersDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/cases/${id}/members/sync`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2FindAll
   * @summary Get list of all tasks (V2)
   * @request GET:/gtw/case/v2/tasks
   * @secure
   * @response `200` `(ApiTaskResponseV2)[]` List of tasks successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2FindAll = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      filter?: "assigned_to_me" | "created_by_me";
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiTaskResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2Create
   * @summary Create a new task (V2)
   * @request POST:/gtw/case/v2/tasks
   * @secure
   * @response `201` `ApiTaskResponseV2` Task successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2Create = (
    data: ApiCreateTaskDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiTaskResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2FindOne
   * @summary Get a task by ID (V2)
   * @request GET:/gtw/case/v2/tasks/{id}
   * @secure
   * @response `200` `ApiTaskResponseV2` Task successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2FindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiTaskResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/tasks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2Update
   * @summary Update a task (V2)
   * @request PUT:/gtw/case/v2/tasks/{id}
   * @secure
   * @response `200` `ApiTaskResponseV2` Task successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2Update = (
    id: string,
    data: ApiUpdateTaskDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiTaskResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/tasks/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2Delete
   * @summary Delete a task (V2)
   * @request DELETE:/gtw/case/v2/tasks/{id}
   * @secure
   * @response `204` `void` Task successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2Delete = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/tasks/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2AddDocuments
   * @summary Add documents to a task (V2)
   * @request POST:/gtw/case/v2/tasks/{id}/documents
   * @secure
   * @response `200` `ApiTaskResponseV2` Task documents successfully added
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2AddDocuments = (
    id: string,
    data: ApiAddTaskDocumentsDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiTaskResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/tasks/${id}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Tasks V2
   * @name TaskControllerV2RemoveDocument
   * @summary Remove a document from a task (V2)
   * @request DELETE:/gtw/case/v2/tasks/{id}/documents/{documentId}
   * @secure
   * @response `200` `ApiTaskResponseV2` Task document successfully removed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  taskControllerV2RemoveDocument = (
    id: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiTaskResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/tasks/${id}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Activity Logs
   * @name ActivityLogControllerFindAll
   * @summary Get list of activity logs
   * @request GET:/gtw/case/activity-logs
   * @secure
   * @response `200` `(ApiActivityLogResponse)[]` List of activity logs successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  activityLogControllerFindAll = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
      /* Template custom: data-contract-jsdoc */
      entityType?: string;
      /* Template custom: data-contract-jsdoc */
      entityId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiActivityLogResponse[], ApiBaseError>({
      path: `/gtw/case/activity-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Activity Logs
   * @name ActivityLogControllerCreate
   * @summary Create a new activity log
   * @request POST:/gtw/case/activity-logs
   * @secure
   * @response `201` `ApiActivityLogResponse` Activity log successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  activityLogControllerCreate = (
    data: ApiCreateActivityLogDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiActivityLogResponse, ApiBaseError>({
      path: `/gtw/case/activity-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Activity Logs
   * @name ActivityLogControllerFindOne
   * @summary Get an activity log by ID
   * @request GET:/gtw/case/activity-logs/{id}
   * @secure
   * @response `200` `ApiActivityLogResponse` Activity log successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  activityLogControllerFindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiActivityLogResponse, ApiBaseError>({
      path: `/gtw/case/activity-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2FindAll
   * @summary Get list of all documents (V2)
   * @request GET:/gtw/case/v2/documents
   * @secure
   * @response `200` `(ApiDocumentResponseV2)[]` List of documents successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2FindAll = (params: RequestParams = {}) =>
    this.request<ApiDocumentResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/documents`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2Create
   * @summary Create a new document (V2)
   * @request POST:/gtw/case/v2/documents
   * @secure
   * @response `201` `ApiDocumentResponseV2` Document successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2Create = (
    data: ApiCreateDocumentDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2FindOne
   * @summary Get a document by ID (V2)
   * @request GET:/gtw/case/v2/documents/{id}
   * @secure
   * @response `200` `ApiDocumentResponseV2` Document successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2FindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2Update
   * @summary Update a document (V2)
   * @request PUT:/gtw/case/v2/documents/{id}
   * @secure
   * @response `200` `ApiDocumentResponseV2` Document successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2Update = (
    id: string,
    data: ApiUpdateDocumentDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2Delete
   * @summary Delete a document (V2)
   * @request DELETE:/gtw/case/v2/documents/{id}
   * @secure
   * @response `204` `void` Document successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2Delete = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2CreateMultipart
   * @summary Create a new document via multipart (V2)
   * @request POST:/gtw/case/v2/documents/multipart
   * @secure
   * @response `201` `ApiDocumentResponseV2` Document successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2CreateMultipart = (
    data: ApiCreateDocumentMultipartBodyDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/multipart`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2AddToCase
   * @summary Add document to a case (V2)
   * @request POST:/gtw/case/v2/documents/{id}/add-to-cases
   * @secure
   * @response `200` `ApiDocumentResponseV2` Document successfully added to case
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2AddToCase = (
    id: string,
    data: ApiAddDocumentToCaseDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}/add-to-cases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2MarkAsRead
   * @summary Mark document as read (V2)
   * @request POST:/gtw/case/v2/documents/{id}/mark-as-read
   * @secure
   * @response `200` `ApiDocumentResponseV2` Document successfully marked as read
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2MarkAsRead = (id: string, params: RequestParams = {}) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}/mark-as-read`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2Download
   * @summary Download a document (V2)
   * @request POST:/gtw/case/v2/documents/download
   * @secure
   * @response `200` `ApiDocumentDownloadResponse` Document file content
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2Download = (
    data: ApiDownloadDocumentDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentDownloadResponse, ApiBaseError>({
      path: `/gtw/case/v2/documents/download`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2DownloadStream
   * @summary Download a document as stream (V2)
   * @request POST:/gtw/case/v2/documents/download/stream
   * @secure
   * @response `200` `void` Document file stream
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2DownloadStream = (
    data: ApiDownloadDocumentDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/documents/download/stream`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2DownloadStream
   * @summary Download a document as stream (V2)
   * @request POST:/gtw/case/v2/documents/download/stream
   * @secure
   * @response `200` `void` Document file stream
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2DownloadStream = (
    data: ApiDownloadDocumentDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/documents/download/stream`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2DownloadStream
   * @summary Download a document as stream (V2)
   * @request POST:/gtw/case/v2/documents/download/stream
   * @secure
   * @response `200` `void` Document file stream
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2DownloadStream = (data: ApiDownloadDocumentDto, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/v2/documents/download/stream`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Documents V2
   * @name DocumentControllerV2RemoveFromCase
   * @summary Remove document from a case (V2)
   * @request POST:/gtw/case/v2/documents/{id}/remove-from-cases
   * @secure
   * @response `200` `ApiDocumentResponseV2` Document successfully removed from case
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentControllerV2RemoveFromCase = (
    id: string,
    data: ApiRemoveDocumentFromCaseDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/documents/${id}/remove-from-cases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns KPI metrics and chart data for dashboard visualization. Founder sees all cases, Member sees only their cases.
   *
   * @tags Analytics
   * @name AnalyticsControllerGetAnalytics
   * @summary Get analytics dashboard data
   * @request GET:/gtw/case/analytics
   * @secure
   * @response `200` `ApiAnalyticsResponse` Analytics data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized - invalid or missing JWT token
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Case not found or user does not have access
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  analyticsControllerGetAnalytics = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAnalyticsResponse, ApiBaseError>({
      path: `/gtw/case/analytics`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns detailed analytics for tasks including status distribution, priority breakdown, and performance metrics.
   *
   * @tags Analytics
   * @name AnalyticsControllerGetTasksAnalytics
   * @summary Get detailed tasks analytics
   * @request GET:/gtw/case/analytics/tasks
   * @secure
   * @response `200` `ApiAnalyticsResponse` Tasks analytics data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  analyticsControllerGetTasksAnalytics = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAnalyticsResponse, ApiBaseError>({
      path: `/gtw/case/analytics/tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns detailed analytics for VFO members including activity, distribution, and engagement metrics.
   *
   * @tags Analytics
   * @name AnalyticsControllerGetMembersAnalytics
   * @summary Get detailed members analytics
   * @request GET:/gtw/case/analytics/members
   * @secure
   * @response `200` `ApiAnalyticsResponse` Members analytics data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  analyticsControllerGetMembersAnalytics = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAnalyticsResponse, ApiBaseError>({
      path: `/gtw/case/analytics/members`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns detailed analytics for documents including upload trends, type distribution, and access patterns.
   *
   * @tags Analytics
   * @name AnalyticsControllerGetDocumentsAnalytics
   * @summary Get detailed documents analytics
   * @request GET:/gtw/case/analytics/documents
   * @secure
   * @response `200` `ApiAnalyticsResponse` Documents analytics data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  analyticsControllerGetDocumentsAnalytics = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAnalyticsResponse, ApiBaseError>({
      path: `/gtw/case/analytics/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns detailed analytics for cases including status distribution, activity levels, and member engagement.
   *
   * @tags Analytics
   * @name AnalyticsControllerGetCasesAnalytics
   * @summary Get detailed cases analytics
   * @request GET:/gtw/case/analytics/cases
   * @secure
   * @response `200` `ApiAnalyticsResponse` Cases analytics data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  analyticsControllerGetCasesAnalytics = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiAnalyticsResponse, ApiBaseError>({
      path: `/gtw/case/analytics/cases`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members
   * @name CaseMemberControllerCreateCaseMember
   * @summary Create case member (Internal)
   * @request POST:/gtw/case/case-members/internal
   * @secure
   * @response `201` `ApiCaseMemberResponse` Case member successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerCreateCaseMember = (
    data: ApiCreateCaseMemberInternalDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberResponse, ApiBaseError>({
      path: `/gtw/case/case-members/internal`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members
   * @name CaseMemberControllerDeleteCaseMember
   * @summary Delete case member (Internal)
   * @request DELETE:/gtw/case/case-members/internal/{profileId}/tenant-profile/{tenantProfileId}
   * @secure
   * @response `200` `ApiSuccessResponse` Case member successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerDeleteCaseMember = (
    profileId: number,
    tenantProfileId: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/case/case-members/internal/${profileId}/tenant-profile/${tenantProfileId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2FindAll
   * @summary Get list of VFO members based on user role (V2)
   * @request GET:/gtw/case/v2/case-members
   * @secure
   * @response `200` `(ApiCaseMemberEnrichedResponseV2)[]` List of VFO members successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2FindAll = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      profileIds?: number[];
      /* Template custom: data-contract-jsdoc */
      excludeProfileIds?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberEnrichedResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/case-members`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2FindAllByProfile
   * @summary Get list of VFO members grouped by profile (V2)
   * @request GET:/gtw/case/v2/case-members/by-profile
   * @secure
   * @response `200` `(ApiCaseMemberGroupedResponseV2)[]` Grouped list of VFO members successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2FindAllByProfile = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      profileIds?: number[];
      /* Template custom: data-contract-jsdoc */
      excludeProfileIds?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberGroupedResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/case-members/by-profile`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2FindAllByProfile
   * @summary Get list of VFO members grouped by profile (V2)
   * @request GET:/gtw/case/v2/case-members/by-profile
   * @secure
   * @response `200` `(ApiCaseMemberGroupedResponseV2)[]` Grouped list of VFO members successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2FindAllByProfile = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      profileIds?: number[];
      /* Template custom: data-contract-jsdoc */
      excludeProfileIds?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberGroupedResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/case-members/by-profile`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2FindAllByProfile
   * @summary Get list of VFO members grouped by profile (V2)
   * @request GET:/gtw/case/v2/case-members/by-profile
   * @secure
   * @response `200` `(ApiCaseMemberGroupedResponseV2)[]` Grouped list of VFO members successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2FindAllByProfile = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      profileIds?: number[];
      /* Template custom: data-contract-jsdoc */
      excludeProfileIds?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberGroupedResponseV2[], ApiBaseError>({
      path: `/gtw/case/v2/case-members/by-profile`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2Update
   * @summary Update a case member (V2)
   * @request PUT:/gtw/case/v2/case-members/{caseId}/profile/{profileId}
   * @secure
   * @response `200` `ApiCaseMemberResponseV2` Case member successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2Update = (
    caseId: string,
    profileId: number,
    data: ApiUpdateCaseMemberDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/case-members/${caseId}/profile/${profileId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Case Members V2
   * @name CaseMemberControllerV2UpdateSelf
   * @summary Update own case member data (V2)
   * @request PUT:/gtw/case/v2/case-members/self
   * @secure
   * @response `200` `ApiCaseMemberResponseV2` Case member successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  caseMemberControllerV2UpdateSelf = (
    data: ApiUpdateCaseMemberSelfDtoV2,
    params: RequestParams = {},
  ) =>
    this.request<ApiCaseMemberResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/case-members/self`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetAllPermissions
   * @summary Get all permissions
   * @request GET:/gtw/case/permissions
   * @secure
   * @response `200` `(ApiPermissionResponse)[]` List of all permissions
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetAllPermissions = (params: RequestParams = {}) =>
    this.request<ApiPermissionResponse[], ApiBaseError>({
      path: `/gtw/case/permissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetAllRoles
   * @summary Get all roles
   * @request GET:/gtw/case/permissions/roles
   * @secure
   * @response `200` `(ApiRoleResponse)[]` List of all roles
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetAllRoles = (params: RequestParams = {}) =>
    this.request<ApiRoleResponse[], ApiBaseError>({
      path: `/gtw/case/permissions/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetRolePermissions
   * @summary Get role permissions
   * @request GET:/gtw/case/permissions/roles/{roleId}/permissions
   * @secure
   * @response `200` `(ApiPermissionResponse)[]` List of permissions for a role
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetRolePermissions = (
    roleId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiPermissionResponse[], ApiBaseError>({
      path: `/gtw/case/permissions/roles/${roleId}/permissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetUserPermissions
   * @summary Get user permissions
   * @request GET:/gtw/case/permissions/users/{profileId}/permissions
   * @secure
   * @response `200` `void` List of all permissions for a user
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetUserPermissions = (
    profileId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/permissions`,
      method: "GET",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGrantPermission
   * @summary Grant permission to user (FOUNDER only)
   * @request POST:/gtw/case/permissions/users/{profileId}/permissions
   * @secure
   * @response `201` `ApiUserPermissionResponse` Permission successfully granted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGrantPermission = (
    profileId: number,
    data: ApiGrantPermissionDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiUserPermissionResponse, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/permissions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetUserRoles
   * @summary Get user roles
   * @request GET:/gtw/case/permissions/users/{profileId}/roles
   * @secure
   * @response `200` `(ApiUserRoleResponse)[]` List of roles for a user
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetUserRoles = (
    profileId: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiUserRoleResponse[], ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGrantRole
   * @summary Grant role to user (FOUNDER only)
   * @request POST:/gtw/case/permissions/users/{profileId}/roles
   * @secure
   * @response `201` `ApiUserRoleResponse` Role successfully granted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGrantRole = (
    profileId: number,
    data: ApiGrantRoleDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiUserRoleResponse, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/roles`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerRevokeRole
   * @summary Revoke role from user (FOUNDER only)
   * @request DELETE:/gtw/case/permissions/users/{profileId}/roles/{roleId}
   * @secure
   * @response `204` `void` Role successfully revoked
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerRevokeRole = (
    profileId: number,
    roleId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/roles/${roleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerRevokePermission
   * @summary Revoke permission from user (FOUNDER only)
   * @request DELETE:/gtw/case/permissions/users/{profileId}/permissions/{permissionId}
   * @secure
   * @response `204` `void` Permission successfully revoked
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerRevokePermission = (
    profileId: number,
    permissionId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/permissions/${permissionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerGetChatPermissions
   * @summary Get user chat permissions
   * @request GET:/gtw/case/permissions/users/{profileId}/chat-permissions
   * @secure
   * @response `200` `ApiChatPermissionResponse` Chat permissions for a user
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerGetChatPermissions = (
    profileId: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiChatPermissionResponse, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/chat-permissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionControllerUpdateChatPermissions
   * @summary Update user chat permissions (FOUNDER only)
   * @request PUT:/gtw/case/permissions/users/{profileId}/chat-permissions
   * @secure
   * @response `200` `ApiChatPermissionResponse` Chat permissions successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  permissionControllerUpdateChatPermissions = (
    profileId: number,
    data: ApiUpdateChatPermissionsDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiChatPermissionResponse, ApiBaseError>({
      path: `/gtw/case/permissions/users/${profileId}/chat-permissions`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns all widget data for dashboard. Founder sees all VFO data, Member sees only accessible cases.
   *
   * @tags Dashboard V2
   * @name DashboardControllerV2GetDashboard
   * @summary Get dashboard data (V2)
   * @request GET:/gtw/case/v2/dashboard
   * @secure
   * @response `200` `ApiDashboardResponseV2` Dashboard data successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized - invalid or missing JWT token
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  dashboardControllerV2GetDashboard = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      caseId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiDashboardResponseV2, ApiBaseError>({
      path: `/gtw/case/v2/dashboard`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
